import axios from 'axios';
import CryptoJS from 'crypto-js';
import { handleLogout } from '../../utility/utility';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '/api/';
const SECRETKEY = 'SKILLED@2024';

const client = axios.create({
    baseURL: API_ENDPOINT,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

client.interceptors.request.use(async (config) => {
    const requestConfig = config;
    const { headers } = config;

    try {
        const response = await axios.get(`${API_ENDPOINT}checkCustomerValid`, {
            withCredentials: true,
        });

        requestConfig.headers = {
            ...headers,
            Authorization: `Bearer ${response.data.accessToken}`,
        };

        return requestConfig;
    } catch (error) {
        handleLogout();
        return Promise.reject(error);
    }
});

class DataService {
    static get(path = '') {
        return client({
            method: 'GET',
            url: path,
            headers: {},
        });
    }

    static post(path = '', data = {}, optionalHeader = {}) {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRETKEY).toString();

        return client({
            method: 'POST',
            url: path,
            data: { encryptedData },
            headers: { ...optionalHeader },
        });
    }

    static delete(path = '', data = {}) {
        return client({
            method: 'DELETE',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }
}

export { DataService };
